"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Router = require("./Router");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Link extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "props", void 0);

    _defineProperty(this, "_handleClick", event => {
      this.props.onClick && this.props.onClick(event);

      if (event.ctrlKey || event.shiftKey || event.altKey || event.metaKey) {
        return;
      }

      event.preventDefault();

      if (!this.props.to) {
        return;
      }

      const path = `${this.props.to}.html`;

      try {
        if (_Router.history) {
          _Router.history.push(path);
        } else {
          throw new Error('');
        }
      } catch (e) {
        if (!e.message.startsWith("Failed to execute 'pushState' on 'History'")) {
          // Google Chrome throws for file URLs
          throw e;
        }

        const {
          pathname
        } = window.location;

        if (pathname.endsWith('/')) {
          window.location.pathname = `${pathname}/${path}`;
        } else {
          const parts = pathname.split('/');
          parts.pop();
          window.location.pathname = `${parts.join('/')}/${path}`;
        }
      }
    });
  }

  render() {
    const _this$props = this.props,
          {
      to
    } = _this$props,
          rest = _objectWithoutProperties(_this$props, ["to"]);

    return _react.default.createElement("a", _extends({}, rest, {
      href: to ? `${to}.html` : '',
      onClick: this._handleClick
    }));
  }

}

exports.default = Link;
//# sourceMappingURL=Link.js.map